import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IRatingAndFeedback } from "src/services/types";
import { toast } from 'react-toastify';
// import { SearchTable } from "src/components/Common/SearchTable";
import { Col, Row } from "reactstrap";
import { ColumnsUsersRatingAndFeedback } from "./ColumnsUsersRatingAndFeedback";
import { getRatingAndFeedbackUsers } from "src/services/general-service";

export const RatingAndFeedback = () => {
    document.title = "Secure | Rating and Feedback";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<IRatingAndFeedback[]>([]);

  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
  });

  const fetchData = async (config: IConfig) => {
    setIsLoading(true);
    const configAux = { ...config };
    if(configAux.is_verified_by_admin === 'all') {
      delete configAux.is_verified_by_admin;
    }
    const res = await getRatingAndFeedbackUsers(configAux)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res.data.pagination.total);
        setUsers(res.data.data);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }
  
  const refresh = () => {
    fetchData(config);
  }
  
  useEffect(() => {
    fetchData(config);
  }, [config]);

  return (
    <div className="page-content">
      <h2 className="text-primary mb-3">Rating and Feedback Users</h2>

      <Row className="mb-2">
        <Col sm={12} className="d-flex align-items-end justify-content-start gap-2">
            <button
                type="button"
                className="btn btn-soft-primary waves-effect waves-light"
                onClick={refresh}
            >
                <i className="fas fa-sync-alt"></i> Refresh table
            </button>
        </Col>
        {/* <Col sm={6} className="d-flex justify-content-end align-items-end" >
            <div className="w-75">
              <SearchTable 
                  onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                  loading={isLoading && !!config.search}
                  className=""
              />
            </div>
        </Col> */}
      </Row>
      
      <ContentDataTable isLoading={isLoading}>
          <DataTable
              customStyles={{
                rows: { style: { minHeight: '50px' }},
                table: { style: { minHeight: '400px'}},
                cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
              }}
              columns={ColumnsUsersRatingAndFeedback(
                config, 
              )}
              data={users}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              responsive
              onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
              onChangePage={(page) => setConfig({ ...config, page })}
              paginationDefaultPage={config.page}
              paginationPerPage={config.per_page}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              noDataComponent={
                  <SectionNoData
                      onRefresh={() => fetchData(config)}
                      isLoading={isLoading}
                  />
              }
          />
      </ContentDataTable>
    </div>
  )
}